/* jshint esversion: 6 */

const getEnv = function () {
  console.log(process.env.NODE_ENV);
  if (process.env.NODE_ENV === 'development') {
    const apiBase = process.env.VUE_APP_WORKSN_API_BASE;
    return apiBase ? apiBase.replace(/\/?$/, '/') : '//worksntest.hzwxbz999.cn/api/v1/';
  } else {
    switch (window.location.hostname) {
      // 悦玩测试预发域名
      case 'yw-worksn-manage-test.xdi2.cn':
        return '//yw-worksn-test.xdi2.cn/api/v1/';
      case 'yw-worksn-manage-pre.yuwanc.com':
          return '//yw-worksn-pre.yuwanc.com/api/v1/';
      case 'yw-worksn-manage.yuwanc.com':
          return '//yw-worksn.yuwanc.com/api/v1/';


      case 'worksntest.hzwxbz999.cn':
      case 'worksn-manage-test.hzwxbz999.cn':
        return '//worksntest.hzwxbz999.cn/api/v1/';
      case 'worksnpre.hzwxbz999.cn':
      case 'worksn-manage-pre.hzwxbz999.cn':
        return '//worksnpre.hzwxbz999.cn/api/v1/';
      default:
        return '//worksn.hzwxbz2.cn/api/v1/';
    }
  }
};
export const getWebsocket = function () {
  if (process.env.NODE_ENV === 'development') {
    return 'ws://worksntest.swoole.hzwxbz999.cn';
  } else {
    switch (window.location.hostname) {
      case 'worksntest.hzwxbz999.cn':
      case 'yw-worksn-manage-test.xdi2.cn':
        return 'ws://worksntest.swoole.hzwxbz999.cn';
      case 'worksnpre.hzwxbz999.cn':
      case 'yw-worksn-manage-pre.yuwanc.com':
        return 'ws://worksn.swoole.921game.cn';
      default:
        return 'ws://worksn.swoole.hzwxbz2.cn';
    }
  }
};

// 获取钉钉登录公共平台的域名
export const getBaseUrl = function () {
  if (process.env.NODE_ENV === 'development') {
    return '//basetest.hzwxbz999.cn';
  } else {
    switch (window.location.hostname) {
      case 'worksntest.hzwxbz999.cn':
      case 'yw-worksn-manage-test.xdi2.cn':
        return '//basetest.hzwxbz999.cn';
      case 'worksnpre.hzwxbz999.cn':
      case 'yw-worksn-manage-pre.yuwanc.com':
      case 'worksn-manage-pre.hzwxbz999.cn':
        return '//basepre.hzwxbz999.cn';
      default:
        return '//base.hzwxbz2.cn';
    }
  }
};

export const isV2Url = () => {
  const V2_URL = ['worksn.hzwxbz2.cn'];
  return V2_URL.includes(window.location.hostname);
};

// 是都是悦玩域名
export const isYuewanLocation = () => {
  const YUEWAN_LOCATION = ['yw-worksn-manage-test.xdi2.cn', 'yw-worksn-manage-pre.yuwanc.com', 'yw-worksn-manage.yuwanc.com'];
  return YUEWAN_LOCATION.includes(window.location.hostname);
};

// export default getEnv();
export default getEnv();
